angular.module('jv.Candidate.Profile.Factory', [])
.factory('jvCandidateProfileFactory',['$timeout', 'jvCandidatesService', '$rootScope','$q','$routeParams', 'months', 'years',
    function($timeout, jvCandidatesService, $rootScope, $q, $routeParams, months, years) {
        
        var candidateProfileFactory = {
            profile : {
                data: null,
                subscribers: [],
                fetchInProgress: false,
            },
            degreeTypeMap : {
                'label': 'Degree Type',
                'name': 'DegreeType',
                'values':[
                {
                    'label': 'None',
                    'name' : 'None',
                    'value': '0'
                },
                {
                    'label': 'Associate',
                    'name' : 'Associate',
                    'value': '1'
                },
                {
                    'label': 'Bachelor',
                    'name' :  'Bachelor',
                    'value': '2'
                },
                {
                    'label': 'Masters',
                    'name' : 'Masters',
                    'value': '3'
                },
                {
                    'label': 'Doctorate',
                    'name' : 'Doctorate',
                    'value': '4'
                },
                {
                    'label': 'Unspecified',
                    'name' : 'Unspecified',
                    'value': '5'
                }
                ]
            },
            yearValues  : angular.copy(years.getYears()),
            //resolve month and year values to display on the UI 
            resolveMonthAndYear : function(workHistory){
                var self = this;
                angular.forEach(workHistory,function(workHistoryItem,key){
                    //month values can be 0 check for ! null 
                    if(workHistoryItem.startMonth!== null){
                        workHistoryItem.startMonth = months.formats.fullmonths[workHistoryItem.startMonth-1];
                    }
                    if(workHistoryItem.endMonth !== null){
                        workHistoryItem.endMonth = months.formats.fullmonths[workHistoryItem.endMonth-1];
                    }
                    if(workHistoryItem.startYear !== null){
                        angular.forEach(self.yearValues,function(yearObj,key){
                            if( parseInt(yearObj.value,10) === workHistoryItem.startYear){
                                workHistoryItem.startYear = yearObj;
                            }
                        });
                    }
                    if(workHistoryItem.endYear !== null ){
                       angular.forEach(self.yearValues,function(yearObj,key){
                            if(parseInt(yearObj.value,10)  === workHistoryItem.endYear){
                                workHistoryItem.endYear = yearObj;
                            }
                        });
                    }
                });
                return workHistory;
            },
            //resolve degreeTypeValue to object to display on the UI 
            resolveDegreeType : function(educationHistory){
                var self = this;
                angular.forEach(educationHistory,function(education,key){
                    if(education.degreeType !== null){
                        education.degreeType = self.degreeTypeMap.values[education.degreeType];
                    }
                });
                return educationHistory;
            },
            saveProfileData: function(data) {
                var self = this;
                self.profile.data = data;
                //resolveDegreeType from integer values to string 
                self.profile.data.education = self.resolveDegreeType(data.education);
                self.profile.data.workHistory = self.resolveMonthAndYear(data.workHistory);
                self.profile.fetchInProgress = false;
            },
            //method to call all subscribers
            callSubscribers: function(data){
                var self = this;
                angular.forEach(self.profile.subscribers,function(subscriber,index){
                    subscriber.call(self,data);
                });
            },
            //sort education history items
            sortEducationHistoryItem : function(propertyName){
                return function(a, b){
                    var date1 = new Date(a[propertyName]).getFullYear();
                    var date2 = new Date(b[propertyName]).getFullYear();
                    //check months if year is same
                    if(date1 === date2){
                        date1 = new Date(a[propertyName]).getMonth();
                        date2 = new Date(b[propertyName]).getMonth();
                    }
                    if (date1 < date2)
                        return -1;
                    else if (date1 > date2){
                        return 1;
                    }
                    else{
                        return 0;
                    }
                };
            },
            //sort work history items
            sortWorkHistoryItem : function(propertyName){
                return function(a, b){
                    var date1 = a[propertyName];
                    var date2 = b[propertyName];
                    //check months if year is same
                    if(date1 === date2){
                        date1 = a['startMonth'];
                        date2 = b['startMonth'];
                    }
                    if ( date1 < date2 )
                        return -1;
                    else if (date1 > date2){
                        return 1;
                    }
                    else{
                        return 0;
                    }
                };
            },
            //save workHistory
            saveWorkHistory: function(args,callback){
                var self = this;
                args.applicationId  =  $routeParams.applicationId;
                jvCandidatesService.saveWorkHistory(args, function(response){
                    if(response && response.status === 200){
                        if(!$.isEmptyObject(response.data)){
                        var data = response.data;
                            data.workHistory = data.workHistory.sort(self.sortWorkHistoryItem('startYear')).reverse();
                            self.saveProfileData(data);
                            self.callSubscribers(data);
                            if(callback){
                                callback(response);
                            }
                        }
                    }
                });
            },
            //save educationHistory
            saveEducationHistory: function(args,callback){
                var self = this;
                args.applicationId  =  $routeParams.applicationId;
                jvCandidatesService.saveEducationHistory(args, function(response){
                    if(response && response.status === 200){
                        if(!$.isEmptyObject(response.data)){
                            var data = response.data;
                            data.education = data.education.sort(self.sortEducationHistoryItem('startDate')).reverse();
                            self.saveProfileData(data);
                            self.callSubscribers(data);
                            if(callback){
                                callback(response);
                            }
                        }
                    }
                });
            },
            //register subscribers who will be called when profile.data changes via GET or POST 
            registerSubscribers : function(subscriberList){
                this.profile.subscribers = this.profile.subscribers.concat(subscriberList);
            },
            //resets the subscribers
            resetSubscribers : function () {
                this.profile.subscribers = [];
            },
            //get profileHistory 
            getProfileHistoryData: function(args,callback){
                var self = this;
                if (self.profile.data || self.profile.fetchInProgress) {
                    self.callSubscribers(self.profile.data);
                    if (callback) {
                        callback(self.profile.data);
                    }
                    return;
                }
                self.profile.fetchInProgress = true;
                if(args.canGetWorkAndEducationHistory){
                    jvCandidatesService.getEducationAndWorkHistory(args, function(response) {
                        if (response && response.status === 200) {
                            if(!$.isEmptyObject(response.data)){
                                var data = response.data;
                                data.workHistory = data.workHistory.sort(self.sortWorkHistoryItem('startYear')).reverse();
                                data.education = data.education.sort(self.sortEducationHistoryItem('startDate')).reverse();
                                self.saveProfileData(data);
                                self.callSubscribers(data);
                                if(callback){
                                    callback(response);
                                }
                            }

                        }
                    });
                }
            }
        };
        
        return candidateProfileFactory;
    }
]);
